
import {Options, Vue} from 'vue-class-component';
import 'vue3-carousel/dist/carousel.css';

//@ts-ignore
import {Carousel, Navigation, Slide} from 'vue3-carousel';
import axios from "axios";

@Options({
    props: {
        msg: String
    },
    components: {
        Carousel,
        Slide,
        Navigation,
    },
})
export default class WinnerGallery extends Vue {
    isShowGalleryPopup = false
    galleryIndex = 0
    galleryImages = []
    breakpoints = {
        320: {
            itemsToShow: 1.5,
        },
        700: {
            itemsToShow: 2.5,
        },
        // 1024 and up
        1024: {
            itemsToShow: 4,
        },
    }

    showGallery(index: number) {
        this.galleryIndex = index
        this.isShowGalleryPopup = true
        window.addEventListener('keydown', this.handleKeydown);

    }

    closeGallery() {
        this.isShowGalleryPopup = false
        window.removeEventListener('keydown', this.handleKeydown);
    }

    handleKeydown(e: any) {
        switch (e.keyCode) {
            case 37:
                this.back();
                break;
            case 39:
                this.next();
                break;
        }
    }

    back() {
        if (this.galleryIndex != 0) {
            this.galleryIndex--
        }
    }

    next() {
        if (this.galleryIndex != this.galleryImages.length - 1) {
            this.galleryIndex++
        }
    }


    mounted() {
        this.getWinners()
    }

    getWinners() {
        axios.get('/api/v1/lifeawardwinners').then((data) => {
            if (data?.data?.data.length > 0) {
                this.galleryImages = data.data.data
            }
        })
    }

}
